import { useMemo } from 'react'

import { inAppEnabledStorage } from '@/helpers/notificationCategoryPreferences'
import { CATEGORY_ORDER, NotificationCategory } from '@/types'

import { useLocalStorageItems } from './useLocalStorageItem'

export const useInAppEnabledCategories = (userId: string): Record<NotificationCategory, boolean> => {
    const values = useLocalStorageItems(CATEGORY_ORDER.map(category => inAppEnabledStorage(category, userId)))

    return useMemo(() => {
        // Unset means "never touched", which defaults to enabled (like the storage item's fallback)
        const isEnabled = (category: NotificationCategory): boolean => values[CATEGORY_ORDER.indexOf(category)] ?? true

        return {
            [NotificationCategory.chatMessages]: isEnabled(NotificationCategory.chatMessages),
            [NotificationCategory.feedPost]: isEnabled(NotificationCategory.feedPost),
            [NotificationCategory.repliesToComments]: isEnabled(NotificationCategory.repliesToComments),
            [NotificationCategory.mentions]: isEnabled(NotificationCategory.mentions),
        }
    }, [values])
}
